<template>
    <div class="timeline__wrapper">
        <div :class="{'overlay__open': overlayOpen == true}" class="milestone__wrapper container position-relative">
            <div class="row">
                <div class="animation__overlay">
                    <div class="animation__overlay--inner"></div>
                </div>
                {{moduleStatus}}
                <div class="milestone col-12" :class="{'active': index == snapStopContentIndex}"
                     v-for="(milestone, index) in milestones">

                    <div class="row">
                        <div class="col-8 offset-2 col-lg-4 offset-lg-0 col-xl-6 offset-xl-0 d-flex align-items-md-start align-items-center justify-content-end">
                            <div id="parallax__wrapper" class="parallax__wrapper mr-0 mr-md-5">
                                <div class="hidden__spacer"><img :src="getImage(milestone.year)" class="img-fluid">
                                </div>
                                <div class="parallax--bg" data-depth="0"></div>
                                <img :src="getImage(milestone.year)" data-depth="0.8" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-12 col-md-8 col-xl-6 mt-3 mt-md-0">
                            <div class="milestone__info">
                                <div class="milestone__year font-48 text-md-left text-center"
                                     v-html="milestone.year"></div>
                                <div class="milestone__headline font-bold font-54 text-md-left text-center line-height-110 pb-2"
                                     v-html="milestone.headline"></div>
                                <div class="text-md-left text-center flex-column align-items-center align-items-md-start mt-3 mt-xl-5 d-flex">
                                    <div class="milestone__text font-24 d-none d-md-block"
                                         v-html="milestone.textShort"></div>
                                    <div class="btn btn-red my-0 my-md-3 my-xl-5 mb-4 mb-xl-5 milestone__more" :class="{'seen': milestone.seen}"
                                         v-on:click="toggleOverlay(milestone.year, milestone)" v-html="$t('GLOBAL_LEARN_MORE')">
                                        learn more
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div :class="{'overlay__open': overlayOpen == true}" class="drag__wrapper">
            <div id="dragBounds" class="dragBounds">
                <div class="marker__wrapper" :style="{'width': snapStopsSize* (milestones.length -1)+'px'}">
                    <div :style="{'left':snapStopsSize * index +'px'}" class="marker"
                         :class=" {'active': snapStopIndex == index}" v-for="(milestone, index) in milestones">
                        <div class="marker__inner" v-on:click="jumpToMilestone(index)">{{milestone.year}}</div>
                    </div>
                </div>
                <div id="dragControl">
                    <div class="drag__control--inner"></div>
                </div>
            </div>
        </div>
        <div class="overlay" :class="{'open': overlayOpen == true}">

            <div class="overlay__inner">

                <component :is="component" v-if="component"/>
                <div class="close__overlay">
                    <img src="@/assets/global/close__overlay.svg" class="img-fluid" v-on:click="toggleOverlay()">
                </div>
            </div>

        </div>
        <div class="prev__btn d-flex align-items-center " v-on:click="jumpToMilestone(snapStopIndex-1)" v-if="snapStopIndex - 1 >= 0" :class="{'overlay__open': overlayOpen == true}">
            <div class="d-flex flex-column align-items-start">
                <span v-html="$t('GLOBAL_PREV')">previous</span>
                <div class="next__btn--year">{{milestones[snapStopContentIndex - 1].year}}</div>
            </div>
        </div>
        <div class="next__btn d-flex align-items-center " v-on:click="jumpToMilestone(snapStopIndex+1)" v-if="snapStopIndex + 1 < milestones.length" :class="{'overlay__open': overlayOpen == true}">
            <div class="d-flex flex-column align-items-start">
                <span v-html="$t('GLOBAL_NEXT')">next</span>
                <div class="next__btn--year">{{milestones[snapStopContentIndex +1].year}}</div>
            </div>
        </div>
    </div>

</template>

<script>
    import $ from 'jquery';
    import Parallax from 'parallax-js';
    import LRS from '../services/lrsService';
    import {gsap, TimelineMax, TweenMax, CSSPlugin, Draggable} from 'gsap/all';
    import { mapGetters } from 'vuex'

    gsap.registerPlugin(Draggable)
    export default {
        name: "Timeline",
        data: function () {
            return {
                tl: Object,
                draggable: Object,
                snapStopsSize: 275,
                snapStopIndex: 0,
                snapStopContentIndex: 0,
                snapTreshold: 0.45,
                timelinePositionOffset: 2,
                lastTimelinePositionOffset: 0,
                timelinePositionOffsetAmount: 3,
                lastSavedIndex: 0,
                overlayOpen: false,
                snapStops: [],
                snapValue: 0,
                component: null,
                status: []

            }
        },
        methods: {
          addStatusToTimline(s, milestones){
            for (let i = 0; i < s.length; i++){
                for(let k = 0; k < milestones.length; k++){
                  if(milestones[k].year == s[i][0]){
                    milestones[k].seen = true;
                  }
                }
            }
            console.log(milestones, this.milestones)
          },
          alreadySeen(year){
            console.log(this.moduleStatus, year)
          },
            getImage(name) {
                if (name < 10) {
                    name = "0" + name;
                }
                try {
                    let img;
                    if (name == '1917' || name == '1928' || name == '2016') {
                        img = require('@/assets/milestones/milestone__' + name + '.png');
                    } else {
                        img = require('@/assets/milestones/milestone__' + name + '.jpg');
                    }
                    return img;
                } catch (ex) {
                    return require('@/assets/milestones/milestone__01.png');
                }

            },
            toggleOverlay(year, milestone) {
                if (this.overlayOpen == false) {
                    $('html, body').scrollTop(0);
                    $('.overlay .overlay__inner').scrollTop(0);
                      milestone.seen = true;
                    LRS.sendLRS('experienced', year);
                    LRS.sendLRS('progressed');
                }
                this.overlayOpen = !this.overlayOpen;
                /*let image = $('.overlay .overlay__img');
                let top = image.offset().top;
                let left = image.offset().left;

                var positionInfo = document.querySelector(".overlay__img").getBoundingClientRect();
                var height = positionInfo.height;
                var width = positionInfo.width;
                console.log("Top: ", top, " Left: ", left)

                let d = document.createElement('div');
                console.log(d);
                d.className = "indicator";
                d.style.position = "absolute";
                d.style.left = left+'px';
                d.style.top = top+'px';
                d.style.width = width+'px';
                d.style.height = height+'px';
                document.body.appendChild(d); */
            },
            jumpToMilestone(index) {
                //this.snapStopIndex = index;
                let _this = this;
                this.draggable[0].x = this.snapValue;

                if (this.lastSavedIndex == index) {
                    this.playAnimation(index, true,);
                } else {
                    if (this.lastSavedIndex > index) {
                        this.playAnimation(index);
                    } else {
                        this.playAnimation(index, false, true);
                    }

                }
                this.lastSavedIndex = index;
            },
            // Refactored
            handleDragEnd() {
                let currentX = this.draggable[0].x;
                let ind = Math.round(currentX / this.snapStopsSize);
                this.jumpToMilestone(ind);

            },
            playAnimation(index, skipAnimation = false, backwards = false) {
                let _this = this;
                if (skipAnimation == true) {
                    this.tl = new TimelineMax({});
                    this.tl.add(function () {
                        _this.snapStopIndex = index;
                        TweenMax.to('#dragControl', .25, {
                            x: _this.snapStops[_this.snapStopIndex],
                            ease: "sine",
                            onUpdate: function () {
                                _this.draggable[0].update;
                            }
                        });
                        _this.updateTimelinePosition();
                    })
                    this.tl.add(function () {
                        _this.snapStopContentIndex = _this.snapStopIndex;
                    })
                } else {

                    this.tl = new TimelineMax({});
                    if (backwards == true) {
                        this.tl.set('.animation__overlay--inner', {x: "100%"});
                        this.tl.add(function () {
                            _this.snapStopIndex = index;
                            TweenMax.to('#dragControl', .25, {
                                x: _this.snapStops[_this.snapStopIndex],
                                ease: "sine",
                                onUpdate: function () {
                                    _this.draggable[0].update;
                                }
                            });
                            _this.updateTimelinePosition();
                        })
                        this.tl.to('.animation__overlay--inner', 0.35, {x: "0%"});
                        this.tl.add(function () {
                            _this.snapStopContentIndex = _this.snapStopIndex;
                        })
                        this.tl.to('.animation__overlay--inner', 0.35, {x: "-100%"});
                    } else {
                        this.tl.set('.animation__overlay--inner', {x: "-100%"});
                        this.tl.add(function () {
                            _this.snapStopIndex = index;
                            TweenMax.to('#dragControl', .25, {
                                x: _this.snapStops[_this.snapStopIndex],
                                ease: "sine",
                                onUpdate: function () {
                                    _this.draggable[0].update;
                                }
                            });
                            _this.updateTimelinePosition();
                        })
                        this.tl.to('.animation__overlay--inner', 0.35, {x: "0%"});
                        this.tl.add(function () {
                            _this.snapStopContentIndex = _this.snapStopIndex;
                        })
                        this.tl.to('.animation__overlay--inner', 0.35, {x: "100%"});
                    }


                }


            },
            handleDrag() {
                let _this = this;
                let currentX = this.draggable[0].x;
                let ind = Math.round(currentX / this.snapStopsSize);
                if (ind != this.snapStopIndex) {
                    this.snapStopIndex = ind;
                    //this.playAnimation();
                }
            },
            updateTimelinePosition() {
                let _this = this;


                // console.log(this.lastTimelinePositionOffset, _this.timelinePositionOffset)
                // console.log(this.lastTimelinePositionOffset > _this.timelinePositionOffset)

                if (_this.snapStopIndex > _this.timelinePositionOffset && _this.snapStopIndex < _this.snapStops.length - 1 || _this.lastTimelinePositionOffset > _this.timelinePositionOffset) {
                    // console.log("Timline should move by: ", -(_this.snapStopIndex - this.timelinePositionOffsetAmount) * (_this.snapStopsSize))
                    TweenMax.to('.drag__wrapper', .5, {
                        x: -(_this.snapStopIndex - _this.timelinePositionOffsetAmount) * (_this.snapStopsSize),
                        //ease: "sine",
                        onUpdate: function () {
                            //draggable[0].update;
                        }
                    });
                }
                this.lastTimelinePositionOffset = this.snapStopIndex;
            }
        },
        mounted() {
            let _this = this;
            let images = $('.parallax__wrapper');


            $(images).each(function (index) {
                let img = $(this);
                let parallaxInstance = new Parallax(img[0], {
                    invertX: false,
                    invertY: false
                })
            })

            if ($(window).width() < 1200) {
                this.snapStopsSize = 180;
                this.timelinePositionOffsetAmount = 2;
            }
            if ($(window).width() < 768) {
                this.timelinePositionOffset = 0;
                this.timelinePositionOffsetAmount = 1.5;
                this.snapStopsSize = 100;
                TweenMax.set('.drag__wrapper', {
                    x: 100,
                });
            }
            if ($(window).width() < 340) {
                this.timelinePositionOffset = 0;
                this.timelinePositionOffsetAmount = 1;
                this.snapStopsSize = 100;
                TweenMax.set('.drag__wrapper', {
                    x: 100,
                });
            }


            let dragStop = $(".marker__wrapper");
            let snapStopsSize = this.snapStopsSize;


            // Generate Array with SnapSpots e.g [0, 100, 200, 300], defined by snapStopSize
            for (let i = 0; i < this.milestones.length; i++) {
                this.snapStops.push((i * snapStopsSize));
            }

            let panelCount = this.milestones.length;
            let panelStop = (panelCount - 1) * 2;

            this.draggable = Draggable.create("#dragControl", {
                type: "x",
                throwProps: true,
                bounds: dragStop,
                edgeResistance: 1,
                onDrag: _this.handleDrag,
                onDragEnd: _this.handleDragEnd
            });

            console.log(this.moduleStatus);
            /*for(let i = 0; i < status.length; i++){
              _this.moduleStatus.push(status[i][0]);
            }
            console.log(this.moduleStatus); */
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/components/milestones/1872')
                })
        },
        computed: {
          moduleStatus(){
            let s = this.$store.getters.moduleStatus;
            console.log(this.milestones);
            this.addStatusToTimline(s,this.milestones);
          },
          milestones(){
            return [
              {
                year: 1872,
                headline: this.$i18n.t('MILESTONE_1872_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1872_TEASER_TEXT'),
                id: 1
              },
              {
                year: 1888,
                headline: this.$i18n.t('MILESTONE_1888_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1888_TEASER_TEXT'),
                id: 2
              },
              {
                year: 1897,
                headline: this.$i18n.t('MILESTONE_1897_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1897_TEASER_TEXT'),
                id: 3
              },
              {
                year: 1915,
                headline: this.$i18n.t('MILESTONE_1915_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1915_TEASER_TEXT'),
                id: 4
              },
              {
                year: 1916,
                headline: this.$i18n.t('MILESTONE_1916_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1916_TEASER_TEXT'),
                id: 5
              },
              {
                year: 1917,
                headline: this.$i18n.t('MILESTONE_1917_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1917_TEASER_TEXT'),
                id: 6
              },
              {
                year: 1919,
                headline: this.$i18n.t('MILESTONE_1919_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1919_TEASER_TEXT'),
                id: 7
              },
              {
                year: 1924,
                headline: this.$i18n.t('MILESTONE_1924_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1924_TEASER_TEXT'),
                id: 8
              },
              {
                year: 1928,
                headline: this.$i18n.t('MILESTONE_1928_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1928_TEASER_TEXT'),
                id: 9
              },
              {
                year: 1934,
                headline: this.$i18n.t('MILESTONE_1934_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1934_TEASER_TEXT'),
                id: 10
              },
              {
                year: 1953,
                headline: this.$i18n.t('MILESTONE_1953_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1953_TEASER_TEXT'),
                id: 11
              },
              {
                year: 1963,
                headline: this.$i18n.t('MILESTONE_1963_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1963_TEASER_TEXT'),
                id: 12
              },
              {
                year: 1966,
                headline: this.$i18n.t('MILESTONE_1966_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1966_TEASER_TEXT'),
                id: 13
              },
              {
                year: 1968,
                headline: this.$i18n.t('MILESTONE_1968_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1968_TEASER_TEXT'),
                id: 14
              },
              {
                year: 1976,
                headline: this.$i18n.t('MILESTONE_1976_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1976_TEASER_TEXT'),
                id: 15
              },
              {
                year: 1978,
                headline: this.$i18n.t('MILESTONE_1978_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1978_TEASER_TEXT'),
                id: 16
              },
              {
                year: 1980,
                headline: this.$i18n.t('MILESTONE_1980_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1980_TEASER_TEXT'),
                id: 17
              },
              {
                year: 1984,
                headline: this.$i18n.t('MILESTONE_1984_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1984_TEASER_TEXT'),
                id: 18
              },
              {
                year: 1986,
                headline: this.$i18n.t('MILESTONE_1986_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_1986_TEASER_TEXT'),
                id: 19
              },
              {
                year: 2001,
                headline: this.$i18n.t('MILESTONE_2001_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2001_TEASER_TEXT'),
                id: 20
              }
              , {
                year: 2004,
                headline: this.$i18n.t('MILESTONE_2004_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2004_TEASER_TEXT'),
                id: 21
              },
              {
                year: 2006,
                headline: this.$i18n.t('MILESTONE_2006_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2006_TEASER_TEXT'),
                id: 22
              },
              {
                year: 2009,
                headline: this.$i18n.t('MILESTONE_2009_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2009_TEASER_TEXT'),
                id: 23
              },
              {
                year: 2011,
                headline: this.$i18n.t('MILESTONE_2011_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2011_TEASER_TEXT'),
                id: 24
              },
              {
                year: 2014,
                headline: this.$i18n.t('MILESTONE_2014_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2014_TEASER_TEXT'),
                id: 25
              },
              {
                year: 2016,
                headline: this.$i18n.t('MILESTONE_2016_TEASER_HEADLINE'),
                textShort: this.$i18n.t('MILESTONE_2016_TEASER_TEXT'),
                id: 26
              },
            ]
          },
            loader() {
                let year = this.milestones[this.snapStopIndex].year;
                return () => import('@/components/milestones/' + year);
            },

        },
        watch: {
            snapStopIndex(to, from) {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/components/milestones/1872')
                    })
            },
            overlayOpen(to, from) {

                if (to == true) {
                    $('body').addClass('overflow-hidden');
                } else {
                    $('body').removeClass('overflow-hidden');
                }
            }
        }
    }
</script>

<style scoped lang="scss">


</style>